import ModalSummary from './ModalSummary.styled';

export default ModalSummary;
